import { render, staticRenderFns } from "./UpgradeDialog.vue?vue&type=template&id=d18d8434&scoped=true&"
import script from "./UpgradeDialog.vue?vue&type=script&lang=js&"
export * from "./UpgradeDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeDialog.vue?vue&type=style&index=0&id=d18d8434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18d8434",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
